export default __webpack_public_path__ + "static/media/croptop-small-back.148741c5.jpg";